import { BenefitViewComponentBaseProps } from '.'
import { type BuyAndWinGift } from '../../../../../../typings'
import { GiftView } from '../../../../../Gift'

export function GiftBenefit(
  props: BenefitViewComponentBaseProps<BuyAndWinGift>
) {
  const { config, onEdit, onRemove } = props

  return <GiftView config={config} onEdit={onEdit} onRemove={onRemove} />
}
